import { createContext, useState } from "react";

const LoadingContext = createContext();

const LoadingProvider = ({ children }) => {
  const [appLoading, setAppLoading] = useState(false);

  return (
    <LoadingContext.Provider
      value={{
        appLoading,
        setAppLoading
      }}
    >
      {children}
    </LoadingContext.Provider>
  );
};

export { LoadingProvider };

export default LoadingContext;
